module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c6pX5"))).then(() => parcelRequire('2KbAe'));